// Een id verzinnen in de browser, zodat een notitie die je zonder verbinding maakt al een
// id heeft voordat de server hem ooit gezien heeft. De server kent hetzelfde formaat
// (server/kern/ulid.ts) en weigert alles wat er niet op lijkt.

const LETTERS = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

export function ulid(tijd: number = Date.now()): string {
  let kop = "";
  let rest = tijd;
  for (let i = 0; i < 10; i++) {
    kop = LETTERS[rest % 32] + kop;
    rest = Math.floor(rest / 32);
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let staart = "";
  for (let i = 0; i < 16; i++) staart += LETTERS[bytes[i] % 32];
  return kop + staart;
}
